import React, { useMemo, useEffect, useState } from "react";
import Axios from "axios";
import Icon from "@material-ui/core/Icon";
import moment from "moment-timezone";
import SvgIcon from "@material-ui/core/SvgIcon";
import GYAxios from "../../../util/GYAxios";
import { SITEITCOLS } from "./../../../util/columns";
import { useUser } from "../../../util/user";
import Loader from "./../../general/Loader";
import MaterialTable from "material-table";
import { styleDetails, optionsTable } from "./styleTable";
import AdminSitePreview from "./AdminSitePreview";
import AdminSiteResponse from "./AdminSiteResponse";
import CompareStructureResponse from "./CompareStructureResponse";
import Noti from "../../../util/noti";
import { isDateAfter } from "util/checking";
function AdminTable() {
	const itcols = useMemo(() => SITEITCOLS, []); // columns for IT
	const siteAdmin = useUser().roles.includes(
		"administration:SiteCreation:_admin",
	);

	const [needLoader, setNeedLoader] = useState(false); // need loader or not
	const [showLoader, setShowLoader] = useState({ position: "relative" });

	const [dataTable, setDataTable] = useState([]); // data for table
	const [actionTable, setActionTable] = useState([]); // action for table

	const [ready, setReady] = useState(false); // table is ready or not

	const [showGraph, setShowGraph] = useState("");

	const [isSitePreviewed, setSitePreviewed] = useState(false);
	const [dataPreview, setDataPreview] = useState({});

	const [isSiteResponse, setSiteResponse] = useState(false);
	const [dataResponse, setDataResponse] = useState({});

	const [isModifyPreviewed, setModifyPreviewed] = useState(false);
	const [modifyResponse, setModifyResponse] = useState(null);
	const [modifySource, setModifySource] = useState(null);

	const closeSitePreview = () => {
		setShowGraph("fadeOut");
		setSitePreviewed(false);
		setDataPreview({});
	};

	const openPreview = (siteData) => {
		setShowGraph("fadeIn");
		setSitePreviewed(true);
		setDataPreview(siteData);
	};

	const closeSiteReponse = () => {
		setShowGraph("fadeOut");
		setSiteResponse(false);
		setDataResponse({});
	};

	const openReponse = (data) => {
		setShowGraph("fadeIn");
		setSiteResponse(true);
		setDataResponse(data);
	};

	const closeModifyPreview = () => {
		setShowGraph("fadeOut");
		setModifyPreviewed(false);
		setModifyResponse(null);
		setModifySource(null);
	};

	const openModifyPreview = (source, response) => {
		setShowGraph("fadeIn");
		setModifyPreviewed(true);
		setModifyResponse(response);
		setModifySource(source);
	};

	const formatValue = (value) => {
		if (value === null || value === undefined) return "null";
		return `${value}`;
	};

	function compareStatus(a, b) {
		if (a.sorting < b.sorting) return -1;
		if (a.sorting > b.sorting) return 1;
		return 0;
	}

	const loaderMounted = (boo) => {
		if (boo) {
			setShowLoader({ position: "fixed" });
			setNeedLoader(true);
		} else {
			setShowLoader({ position: "relative" });
			setNeedLoader(false);
		}
	};

	function reload() {
		setReady(false);
		async function fetchData() {
			const _dataTable = await fetchedData();
			const _actionTable = await renderedAction(_dataTable);

			setDataTable(_dataTable);
			setActionTable(_actionTable);
		}
		fetchData();
	}

	const fetchedData = async () => {
		// Get data from back-end for Construction Site Table
		const uri = `/site_creation/pendingsites`;
		try {
			const res = await GYAxios.get(uri);
			const data = await res.data.map((el) => {
				el.pm_date = moment(el.pm_date).format("YYYY-MM-DD");
				el.sync = moment(el.sync).format("YYYY-MM-DD");
				el.cod = moment(el.cod).format("YYYY-MM-DD");

				if (el.exu_site == null) el.sorting = "a";
				else if (el.exu_site !== null && el.isExecuted === 0) el.sorting = "b";
				else if (
					el.exu_site !== null &&
					el.isExecuted === 1 &&
					el.isRejected_acct === 0
				)
					el.sorting = "d";
				else el.sorting = "c";

				return el;
			});

			return data.sort(
				(a, b) =>
					compareStatus(a, b) || moment(b.pm_date).diff(moment(a.pm_date)),
			);
		} catch (error) {
			console.log(error);
			return [];
		}
	};

	const renderedAction = async () => {
		const view_btn = {
			icon: "visibility",
			tooltip: <p style={{ fontSize: "2em" }}>View</p>,
			onClick: (e, row) => openPreview(row),
		};

		const exu_cons_btn = {
			icon: () => <Icon>construction</Icon>,
			tooltip: <p style={{ fontSize: "2em" }}>Run Construction Info</p>,
			onClick: (e, row) => handleClickCons(row, "run"),
		};

		const test_cons_btn = {
			icon: "restore",
			tooltip: <p style={{ fontSize: "2em" }}>Query Construction Info</p>,
			onClick: (e, row) => handleClickCons(row, "query"),
		};

		const done_cons_btn = {
			icon: "check_circle",
			tooltip: <p style={{ fontSize: "2em" }}>Done Construction</p>,
			iconProps: { color: "primary" },
			disable: true,
		};

		const modify_cons_btn = {
			icon: "edit",
			tooltip: <p style={{ fontSize: "2em" }}>Modify Construction Info</p>,
			onClick: (e, row) => handleModifyCons(row),
		};

		const undo_cons_btn = {
			icon: "undo",
			tooltip: <p style={{ fontSize: "2em" }}>Undo Construction</p>,
			onClick: (e, row) => handleUndoCons(row),
		};

		const exu_acct_btn = {
			icon: () => (
				<SvgIcon>
					<path d="M7,2H17A2,2 0 0,1 19,4V20A2,2 0 0,1 17,22H7A2,2 0 0,1 5,20V4A2,2 0 0,1 7,2M7,4V8H17V4H7M7,10V12H9V10H7M11,10V12H13V10H11M15,10V12H17V10H15M7,14V16H9V14H7M11,14V16H13V14H11M15,14V16H17V14H15M7,18V20H9V18H7M11,18V20H13V18H11M15,18V20H17V18H15Z" />
				</SvgIcon>
			),
			tooltip: <p style={{ fontSize: "2em" }}>Run Invoicing Info</p>,
			onClick: (e, row) => handleClickAcct(row, "run"),
		};

		const test_acct_btn = {
			icon: "settings_backup_restore",
			tooltip: <p style={{ fontSize: "2em" }}>Query Invoicing Info</p>,
			onClick: (e, row) => handleClickAcct(row, "query"),
		};

		const update_invoice_info = {
			icon: "currency_exchange",
			tooltip: <p style={{ fontSize: "2em" }}>Update Invoicing Info</p>,
			onClick: (e, row) => update_invoice_info_func(row),
		};

		const del_btn = {
			icon: "delete_sweep",
			tooltip: <p style={{ fontSize: "2em" }}>Delete Permanently</p>,
			onClick: (e, row) => handleDelete(row),
		};

		const unlock_invoice = {
			icon: "vpn_key_off_icon",
			tooltip: <p style={{ fontSize: "2em" }}>Unlock the invoicing info</p>,
			onClick: (e, row) => unlock_invoice_info_func(row),
		};

		const full_btn = {
			icon: "done_all",
			tooltip: <p style={{ fontSize: "2em" }}>All is done!</p>,
			iconProps: { color: "primary" },
			disable: true,
		};

		const within_90_days = (approved_date) => {
			if (approved_date !== null) {
				if (moment().diff(moment(approved_date), "days") <= 90) return true;
				else return false;
			}
			return false;
		};

		return [
			view_btn,
			(rowData) => (rowData.exu_site === null ? test_cons_btn : null),
			(rowData) => (rowData.exu_site === null ? exu_cons_btn : null),
			(rowData) =>
				rowData.exu_site !== null && rowData.isExecuted != 1
					? done_cons_btn
					: null, // only visible when cons_info executed but not invoicing info
			(rowData) =>
				rowData.exu_site !== null &&
				rowData.last_exu_at &&
				isDateAfter(rowData.approval_decided_at, rowData.last_exu_at)
					? modify_cons_btn
					: null, // Modify button visible when cons_info executed but not invoicing info
			(rowData) =>
				rowData.exu_site !== null && rowData.isExecuted === 0
					? undo_cons_btn
					: null, // only visible when cons_info executed but not invoicing info
			(rowData) =>
				rowData.isExecuted === 0 && rowData.isRejected_acct === 0
					? test_acct_btn
					: null,
			(rowData) =>
				rowData.isExecuted === 0 && rowData.isRejected_acct === 0
					? exu_acct_btn
					: null,
			(rowData) => (rowData.isExecuted === 1 ? full_btn : null),
			(rowData) => (rowData.isExecuted === 1 ? unlock_invoice : null),
			(rowData) =>
				rowData.isExecuted === 1 &&
				within_90_days(rowData.approval_decided_at_acct)
					? update_invoice_info
					: null,
			del_btn,
		];
	};

	const moreDetails = (vl) => {
		const acct_sending_status =
			vl.isSent_acct === 1
				? "Sent to Line Manager/ Director for Approval"
				: "Preparing";
		const acct_approval_status =
			vl.isRejected_acct === 1
				? "Rejected"
				: vl.isRejected_acct === 0
					? "Approved"
					: "Pending";
		return (
			<div style={styleDetails}>
				<div style={{ float: "left", width: "50%" }}>
					<p>
						Construction info requestor: {vl.pm_name} on {vl.pm_date}
					</p>
					<ul>
						<li>Estimated COD date: {vl.cod}</li>
						<li>Solo or Multi: {vl.solo === 1 ? "Solo" : "Multi"}</li>
						<li>
							Invoicing Meter: {vl.EDMI_meter === 1 ? "Split" : "Non-split"}
						</li>
						<li>Contract: {vl.contract_id}</li>
						<li>Inverter Number: {vl.nb_inverter}</li>
						<li>Inverter Model: {vl.inverter_id || "empty"}</li>
						<li>Pyranometer Number: {vl.nb_irr_sensors}</li>
						<li>Injection Point Number: {vl.nb_inj_points}</li>
						{vl.DGPT2 !== null && <li>DGPT2: {vl.DGPT2}</li>}
						{vl.water !== null && <li>Water: {vl.water}</li>}
						{vl.wind_dir !== null && <li>Wind Direction: {vl.wind_dir}</li>}
						{vl.wind_speed !== null && <li>Wind Speed: {vl.wind_speed}</li>}
						{vl.pm_comment !== null && <li>Comment: {vl.pm_comment}</li>}
					</ul>
				</div>
				{vl.isSent_acct === 1 && (
					<div>
						<p>
							Invoicing info requestor: {vl.acct_name} on{" "}
							{moment(vl.acct_date).format("YYYY-MM-DD")}
						</p>
						<ul>
							<li>Sending status: {acct_sending_status}</li>
							<li>Approval status: {acct_approval_status}</li>
						</ul>
					</div>
				)}
			</div>
		);
	};

	function updateTableName(newData, rowData, resolve, reject) {
		if (rowData.exu_site !== null) {
			Noti.create({
				type: "w",
				msg: "Site has been created! You can't change its table_name.",
			});
			reject();
			return;
		} else {
			if (newData === null || newData === "") {
				Noti.create({
					type: "w",
					msg: "Your input is empty!",
				});
				reject();
				return;
			} else {
				try {
					GYAxios.patch(`/site_creation/it/${rowData.site_id}/${newData}`)
						.then((res) => {
							if (res.data.affectedRows === 0 || res.data.error !== undefined) {
								res.data.error !== undefined
									? Noti.create({
											type: "e",
											msg: res.data.error,
										})
									: Noti.create({
											type: "e",
											msg: "Something is wrong when affected row is 0!",
										});
								reject();
								return;
							} else {
								rowData.table_name = newData;
								resolve();
							}
						})
						.catch((err) => {
							Noti.create({ type: "e", msg: "Something is wrong" });
							reject();
						});
				} catch (err) {
					Noti.create({ type: "e", msg: "Something is wrong" });
					reject();
				}
			}
		}
	}

	function handleClickCons(data, command) {
		const envisionPath = prompt(
			"Please enter envision site path (NO NEED to add / to the end of the path):",
			"/home/envision/ftp/",
		);
		if (
			envisionPath !== "" &&
			envisionPath !== null &&
			data?.table_name != null
		) {
			if (Object.keys(data).length !== 0) {
				data = {
					...data,
					envisionPath: `${envisionPath}/`,
					command: command,
					codDate: moment(data.cod).add(3, "y").format("YYYY-MM-DD"),
				};

				const newClient = data.client_id === null ? true : false;
				const newModule = data.solar_module_id === null ? true : false;
				const isRollback = data.command === "query" ? true : false;

				const reqArray = [];
				reqArray.push(
					GYAxios.post(
						`/site_creation/it/pm/insertintosites/${data.site_id}`,
						data,
					),
				);
				if (newClient)
					reqArray.push(
						GYAxios.post(
							`/site_creation/it/pm/insertintoclient/${data.site_id}`,
							data,
						),
					);
				if (newModule && !data.is_no_PV)
					reqArray.push(
						GYAxios.post(
							`/site_creation/it/pm/insertintomodule/${data.site_id}`,
							data,
						),
					);
				const needVoltage = data.reference_voltage !== null && data.reference_voltage !== undefined && data.reference_voltage !== "";
				reqArray.push(
					GYAxios.post(`/site_creation/it/pm/creation/${data.site_id}`, data),
				);

				loaderMounted(true);
				Axios.all(reqArray).then(
					Axios.spread((...responses) => {
						const responsesData = responses.map((v) => v.data);
						const errors = responsesData.find((v) => v?.error !== undefined);
						if (errors?.length > 0) {
							Noti.create({ type: "e", msg: "Something is wrong!" });
							loaderMounted(false);
							return;
						}

						loaderMounted(false);

						const insertedObject = {};
						let insertIdSite = 0;
						if (!isRollback) {
							responsesData.forEach((v) => {
								if (!Array.isArray(v)) return;
								if (v.length !== 2) return;
								else {
									insertedObject.temp_client_name = data.temp_client_name;
									if (
										v[0].includes("INSERT INTO") &&
										v[0].includes(".sites (")
									) {
										if (v[1][1] !== undefined && typeof v[1][1] === "object") {
											insertIdSite = v[1][1].insertId;
											insertedObject.insertIdSite = insertIdSite;
										}
									} else if (
										v[0].includes("INSERT INTO") &&
										v[0].includes(".clients_info (")
									) {
										if (v[1][1] !== undefined && typeof v[1][1] === "object")
											insertedObject.insertIdCl = v[1][1].insertId;
									} else if (
										v[0].includes("INSERT INTO") &&
										v[0].includes(".solar_module_models (")
									) {
										if (v[1][1] !== undefined && typeof v[1][1] === "object")
											insertedObject.insertIdMdl = v[1][1].insertId;								
									}
								}
							});

							const afterVoltage = (obj) => {
								GYAxios.post(
									`/site_creation/saving/insertedIDs/${data.site_id}`,
									obj,
								).then((insertRes) => {
									if (insertRes === null) {
										Noti.create({ type: "e", msg: "Something is wrong!" });
										return;
									}

									if (insertRes.data.error !== undefined) {
										Noti.create({ type: "e", msg: "Something is wrong!" });
										return;
									}
								});
							};

							if (needVoltage && insertIdSite !== 0) {
								GYAxios.post(
									`/site_creation/it/pm/insertNormalGridVoltage/${insertIdSite}`,
									data,
								).then((voltRes) => {
									if (voltRes.data && Array.isArray(voltRes.data) && voltRes.data.length === 2) {
										if (voltRes.data[1][1] !== undefined && typeof voltRes.data[1][1] === "object")
											insertedObject.insertIdVolt = insertIdSite;
										responsesData.push(voltRes.data);
									}
									openReponse(responsesData);
									afterVoltage(insertedObject);
								});
							} else {
								openReponse(responsesData);
								afterVoltage(insertedObject);
							}

							if (insertIdSite !== 0) {
								GYAxios.post("/target/init", {
									id: insertIdSite,
									table_name: data.table_name,
								}).then((res_target) => {
									if (res_target.data.error !== undefined) {
										Noti.create({
											type: "e",
											msg: `Inserted this ${data.table_name} into target tables: FAILED!`,
										});
										return;
									} else {
										GYAxios.post(
											"/site_creation/sendingConfirmationToPM",
											data,
										);
										Noti.create({
											type: "s",
											msg: `Inserted this ${data.table_name} into target tables: OK`,
										});
										reload();
									}
								});
							}
						} else {
							openReponse(responsesData);
						}
					}),
				);
			}
		}
	}

	function handleModifyCons(data) {
		const envisionPath = prompt(
			"Please enter envision site path (NO NEED to add / to the end of the path):",
			"/home/envision/ftp/",
		);
		if (Object.keys(data).length !== 0) {
				if (data?.table_name == null) {
					Noti.create({
						type: "w",
						msg: "Table name is missing!",
					});
					return;
				}
				if (envisionPath === "" || envisionPath === null) {
					Noti.create({
						type: "w",
						msg: "Envision path is empty!",
					});
					return;
				}

				data = {
					...data,
					envisionPath: `${envisionPath}/`,
					command: "modify",
				};

				const reqArray = [];

				reqArray.push(
					GYAxios.post(
						`/site_creation/it/pm/compareStructure/${data.site_id}`,
						data,
					),
				);

				loaderMounted(true);
				Axios.all(reqArray).then(
					Axios.spread((...responses) => {
						const responseData = responses[0].data;

						if (responseData?.error !== undefined) {
							Noti.create({ type: "e", msg: responseData.error });
							loaderMounted(false);
							return;
						}

						loaderMounted(false);

						openModifyPreview(data, responseData);
					}),
				);
		}
	}

	function applyModification(data, modifications) {
		const { addedColumns, removedColumns, sitesUpdates, tableName, clientUpdates, voltageUpdates, inverterUpdates } =
			modifications;
		const reqArray = [];

		if (clientUpdates && Object.keys(clientUpdates).length > 0) {
			reqArray.push(
				GYAxios.post(
					`/site_creation/it/pm/insertintoclient/${data.site_id}`,
					data,
				),
			);
		}

		if (voltageUpdates && Object.keys(voltageUpdates).length > 0) {
			reqArray.push(
				GYAxios.post(
					`/site_creation/it/pm/insertNormalGridVoltage/${voltageUpdates.site_id}`,
					data,
				),
			);
		}

		if (sitesUpdates && Object.keys(sitesUpdates).length > 0) {
			reqArray.push(
				GYAxios.post(`/site_creation/it/pm/siteUpdate/${data.site_id}`, {
					tableName: tableName,
					sitesUpdates: sitesUpdates,
				}),
			);
		}

		if (addedColumns && addedColumns.length > 0) {
			reqArray.push(
				GYAxios.post(`/site_creation/it/pm/addColumn/${data.site_id}`, {
					tableName: tableName,
					addedColumns: addedColumns,
				}),
			);
		}

		if (removedColumns && removedColumns.length > 0) {
			reqArray.push(
				GYAxios.post(`/site_creation/it/pm/removeColumn/${data.site_id}`, {
					tableName: tableName,
					removedColumns: removedColumns,
				}),
			);
		}

		if (inverterUpdates && inverterUpdates.length > 0) {
			reqArray.push(
				GYAxios.post(`/site_creation/it/pm/syncInvertersFromCons/${data.site_id}`, {
					tableName: tableName,
				}),
			);
		}

		if (reqArray.length === 0) {
			Noti.create({ type: "w", msg: "No modifications to apply!" });
			return;
		}

		loaderMounted(true);
		Axios.all(reqArray).then(
			Axios.spread((...responses) => {
				const responsesData = responses.map((v) => v.data);
				const errors = responsesData.find((v) => v?.error !== undefined);

				if (errors) {
					Noti.create({ type: "e", msg: errors.error });
					loaderMounted(false);
					return;
				}

				loaderMounted(false);
				openReponse(responsesData);
				Noti.create({
					type: "s",
					msg: `Construction info modified successfully!`,
				});
				reload();
			}),
		);
	}

	const handleApplyModification = () => {
		if (!modifyResponse || !modifySource) return;

		const addedColumns = modifyResponse.addedColumns || [];
		const removedColumns = modifyResponse.removedColumns || [];
		const sitesUpdates = modifyResponse.sitesUpdates || {};
		const clientUpdates = modifyResponse.clientUpdates || {};
		const voltageUpdates = modifyResponse.voltageUpdates || {};
		const inverterUpdates = modifyResponse.inverterUpdates || [];

		const modifications = {
			addedColumns,
			removedColumns,
			sitesUpdates,
			tableName: modifySource.table_name,
			clientUpdates,
			voltageUpdates,
			inverterUpdates,
		};
		closeModifyPreview();
		applyModification(modifySource, modifications);
	};

	function handleUndoCons(data) {
		const question = `Are you sure that you want to undo process of creation of ${data.temp_client_name} - ${data.site_name}?`;
		const uri = `/site_creation/undoProcess`;
		if (Object.keys(data).length !== 0) {
			if (window.confirm(question)) {
				loaderMounted(true);
				GYAxios.post(uri, data).then((res) => {
					if (!Array.isArray(res.data)) {
						Noti.create({ type: "e", msg: "Something is wrong!" });
						loaderMounted(false);
						return;
					}
					if (res.data.length !== 2) {
						Noti.create({ type: "e", msg: "Something is wrong!" });
						loaderMounted(false);
						return;
					}

					loaderMounted(false);
					openReponse([
						[
							";Remember to drop table manually.",
							{ note: "Remember to drop table manually." },
						],
					]);
					Noti.create({ type: "s", msg: `Reverted!` });
					reload();
				});
			}
		}
	}

	function handleClickAcct(data, command) {
		const question = `Update Invoicing info for ${data.temp_client_name} - ${data.site_name}?`;
		if (window.confirm(question)) {
			if (Object.keys(data).length !== 0) {
				data = {
					...data,
					command: command,
				};

				const isRollback = data.command === "query" ? true : false;
				const reqArray = [];
				reqArray.push(
					GYAxios.post(
						`/site_creation/it/acct/updateIntoAcct/${data.site_id}`,
						data,
					),
				);
				reqArray.push(
					GYAxios.post(
						`/site_creation/it/acct/updateIntoSite/${data.site_id}`,
						data,
					),
				);

				if (data.postal_id !== null && data.mail_name && data.mail_bill_add && data.mail_phone_no) {
					reqArray.push(
						GYAxios.post(
							`/site_creation/it/acct/addIntoPostal/${data.site_id}`,
							data,
						),
					);
				}

				loaderMounted(true);
				Axios.all(reqArray).then(
					Axios.spread((...responses) => {
						const responsesData = responses.map((v) => v.data);
						const errors = responsesData.find((v) => v?.error !== undefined);
						if (errors?.length > 0) {
							Noti.create({ type: "e", msg: "Something is wrong!" });
							loaderMounted(false);
							return;
						}

						loaderMounted(false);
						openReponse(responsesData);

						if (!isRollback) {
							let isSucessful = true;
							responsesData.forEach((v) => {
								if (!Array.isArray(v)) return;
								if (v.length !== 2) return;
								else {
									if (v[1][1] !== undefined && typeof v[1][1] === "object") {
										isSucessful = isSucessful && v[1][1].affectedRows !== 0;
									}
								}
							});

							if (isSucessful) {
								GYAxios.post("/site_creation/sendingConfirmationToACCT", data);
								reload();
							}
						}
					}),
				);
			}
		}
	}

	function handleDelete(data) {
		const question = `Deleting permanently ${data.temp_client_name} - ${data.site_name}?`;
		if (window.confirm(question)) {
			if (Object.keys(data).length !== 0) {
				loaderMounted(true);
				const uri = `/site_creation/delete_permanent/${data.site_id}`;
				try {
					GYAxios.delete(uri)
						.then((res) => {
							loaderMounted(false);
							reload();
							Noti.create({ type: "s", msg: `Deleted!` });
						})
						.catch((err) => {
							loaderMounted(false);
							Noti.create({ type: "e", msg: `Something is wrong!` });
						});
				} catch (error) {
					loaderMounted(false);
					Noti.create({ type: "e", msg: `Something is wrong!` });
				}
			}
		}
	}

	async function update_invoice_info_func(data) {
		const question = `Please enter the date (DDMMYYYY) from which the invoicing information for ${data.temp_client_name} - ${data.site_name} - ${data.SF_id} should be updated.`;
		// check whether input is following the format of DDMMYYYY or not
		const date = window.prompt(question);
		if (date === null) return;
		if (date.length !== 8 || isNaN(date)) {
			Noti.create({
				type: "w",
				msg: "Your input is not following the format of DDMMYYYY!",
			});
			return;
		}
		if (moment(date, "DDMMYYYY", true).isValid() === false) {
			Noti.create({
				type: "w",
				msg: "Your input is not following the format of DDMMYYYY!",
			});
			return;
		}
		const uri = `/site_creation/update_inv_info_monthlycalc/${data.table_name}?FT_cost=${data.FT_cost}&FT_discount=${data.FT_discount}&price_ON=${data.price_on}&price_OFF=${data.price_off}&price_STD=${data.price_std}&ON_discount=${data.discount_on}&OFF_discount=${data.discount_off}&STD_discount=${data.discount_std}&price_id=${data.price_id}&entity_id=${data.solar_entity}&bank_id=${data.bank_id}&date=${date}`;
		try {
			GYAxios.put(uri)
				.then((res) => {
					if (res.data.message != undefined) {
						Noti.create({ type: "w", msg: res.data.message });
					} else {
						Noti.create({ type: "s", msg: `Updated!` });
					}
				})
				.catch((err) => {
					Noti.create({ type: "e", msg: `Something is wrong!` });
				});
		} catch (error) {
			Noti.create({ type: "e", msg: `Something is wrong!` });
		}
	}

	async function unlock_invoice_info_func(data) {
		const question = `Unlock invoicing info form for ${data.temp_client_name} - ${data.site_name} - ${data.SF_id}?`;
		if (window.confirm(question)) {
			const uri = `/site_creation/unlock_inv_info/${data.acct_id}`;
			try {
				await GYAxios.put(uri)
					.then((res) => {
						if (res.data.message != undefined) {
							Noti.create({ type: "s", msg: `Unlocked!` });
							reload();
						} else {
							Noti.create({ type: "w", msg: res.data.message });
						}
					})
					.catch((err) => {
						console.log(err);
						Noti.create({ type: "e", msg: `Something is wrong!` });
					});
			} catch (error) {
				console.log(error);
				Noti.create({ type: "e", msg: `Something is wrong!` });
			}
		}
	}

	useEffect(() => {
		async function fetchData() {
			const _dataTable = await fetchedData();
			const _actionTable = await renderedAction(_dataTable);

			setDataTable(_dataTable);
			setActionTable(_actionTable);
		}
		fetchData();

		return () => {
			loaderMounted(false);
		}; // eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	useEffect(() => {
		if (dataTable.length > 0) setReady(true);
		else setReady(false);
	}, [dataTable]);

	return (
		<>
			{siteAdmin && (
				<MaterialTable
					title={
						<div>
							<h5>
								Administration Site Creation Table{" "}
								<span
									className="	glyphicon glyphicon-refresh"
									onClick={() => reload()}
								></span>
							</h5>
						</div>
					}
					columns={itcols}
					isLoading={!ready}
					data={dataTable}
					actions={actionTable}
					options={optionsTable(dataTable)}
					style={{ marginBottom: "10px" }}
					detailPanel={(rowData) => moreDetails(rowData)}
					cellEditable={{
						onCellEditApproved: (newData, oldData, rowData, columnDef) =>
							new Promise((resolve, reject) => {
								updateTableName(newData, rowData, resolve, reject);
							}),
					}}
				/>
			)}
			{needLoader && (
				<div className="overlay translucent" style={showLoader}>
					<Loader
						translucent={true}
						customStyle={{
							width: "150px",
							height: "150px",
							position: "fixed",
							left: "50%",
							top: "35%",
						}}
					/>
				</div>
			)}

			{!siteAdmin && (
				<div className="alert alert-danger" role="alert">
					{" "}
					You are not authorized to view this page!
				</div>
			)}

			{isSitePreviewed && (
				<div className="overlay translucent">
					<div id="form-container" className={showGraph}>
						<AdminSitePreview
							closed={closeSitePreview}
							dataPreview={dataPreview}
						/>
					</div>
				</div>
			)}

			{isSiteResponse && (
				<div className="overlay translucent">
					<div id="form-container" className={showGraph}>
						<AdminSiteResponse
							closed={closeSiteReponse}
							dataResponse={dataResponse}
						/>
					</div>
				</div>
			)}

			{isModifyPreviewed && (
				<CompareStructureResponse
					isOpen={isModifyPreviewed}
					showGraph={showGraph}
					response={modifyResponse}
					source={modifySource}
					onClose={closeModifyPreview}
					onApply={handleApplyModification}
					formatValue={formatValue}
				/>
			)}
		</>
	);
}

export default AdminTable;
